import { FamilyMotherAnscNotificationsSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsMotherCivilStatusShared from 'shell/components/shared/ansc-notifications/research-family';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsMotherCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsMotherCivilStatusShared
        items={FamilyMotherAnscNotificationsSubscriptionCrumbs()}
        scope={IdAmbito.Iscrizioni}
      />
    </Fragment>
  );
};

ResearchFamilyNotificationsMotherCivilStatusPage.displayName =
  'Research Family Notifications CivilStatusPage component';

export default ResearchFamilyNotificationsMotherCivilStatusPage;
